import {
  createSlice,
} from '@reduxjs/toolkit';
import Immutable from 'immutable';

export const defaultFilters = Immutable.fromJS({
  filters: {},
  queryFilters: {
    majorProductHandled: [],
    nob: [],
    businessRegion: [],
    country: [],
  },
  openedQuestionIds: [],
});

export const participantFilterSlice = createSlice({
  name: 'participantFilter',
  initialState: defaultFilters,
  reducers: {
    updateFilter(state, action) {
      let newState = state;
      newState = newState.setIn(action.payload.field, action.payload.value);
      return newState;
    },
    resetFilter(state) {
      let newState = defaultFilters;
      newState = newState.setIn(['openedQuestionIds'], state.getIn(['openedQuestionIds']));
      return newState;
    },
  },
});

export const {
  updateFilter, resetFilter,
} = participantFilterSlice.actions;

export default participantFilterSlice.reducer;
